import React from "react";

const IconEdit2 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 24}
      height={props.height || 24}
      fill="none"
      {...props}
    >
      <path
        stroke="#808089"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1M16 5l3 3m1.385-1.415a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3l8.385-8.415Z"
      />
    </svg>
  );
};

export default IconEdit2;
